<template>
  <div v-if="api_key && content && content !== ''">
    <Content
      :model="props.model"
      :content="content"
      :api-key="api_key"
      :customComponents="getRegisteredComponents()"
      :can-track="rootStore.checkConsent(OneTrustCookieGroup.Analytical)"
    />
  </div>
</template>

<script setup lang="ts">
import { Content } from "@builder.io/sdk-vue";
import { REGISTERED_COMPONENTS } from "~/builder/init-builder";
import { BuilderService } from "~/services/builder.service";
import { OneTrustCookieGroup } from "~/assets/constants/cookie-consent";

const nuxtApp = useNuxtApp();

type Props = {
  customComponents?: any;
  path?: string;
  model?: string;
};

const props = withDefaults(defineProps<Props>(), {
  model: "page",
});

function getRegisteredComponents(){
  return REGISTERED_COMPONENTS;
}

const rootStore = useRootStore();
const route = useRoute();
const config = useRuntimeConfig();
const content = ref(null);
const api_key = config.public.builderApiKey;

const builderService = new BuilderService(api_key);

const contentUrlPath = computed(() => props.path || route.path);

try {
  const { data } = await useAsyncData(
    "builder-content-" + contentUrlPath.value,
    () => getBuilderContent(props.model)
  , {
      dedupe: "cancel",
  });
  //@ts-ignore
  content.value = data.value;
} catch (e) {
  const { $customClientErrorHandler } = useNuxtApp();
  let errorMeta = {
    path: contentUrlPath.value,
  }
  $customClientErrorHandler(
    e,
    'high',
    'Builder Service Error - trying to fetch content using getBuilderContent()',
    errorMeta
  );
}

async function getBuilderContent(modelName?: string) {
  try {
    return builderService.getItem(modelName, {
      urlPath: contentUrlPath.value,
    },{},{},nuxtApp);
  } catch (e) {
    const { $customClientErrorHandler } = useNuxtApp();
    let errorMeta = {
      modelName,
      contentUrlPath: contentUrlPath.value,
      builderStoreError: true,
    };

    $customClientErrorHandler(
      e,
      'high',
      'Builder Service Error - trying to fetch builder content using getBuilderContent()',
      errorMeta
    );
    return e;
  }

}
</script>
